import React from "react";
import { Form } from "react-bootstrap";
import { DynamicIcon } from "lucide-react/dynamic";

export default class ITabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      navItems: props.navItems,
      selected: props.selected,
      container: props.container,
      content: props.navItems[props.selected].component,
    };
  }

  icon = (name, size = 20, strokeWidth = 1.2) => {
    if (!name) {
      name = "info";
    }
    return <DynamicIcon name={name} size={size} strokeWidth={strokeWidth} />;
  };

  _setContent = (event, component) => {
    const T = document.getElementsByClassName("tab-active");
    T[0].classList.remove("tab-active");
    event.target.classList.add("tab-active");
    this.setState({
      content: component,
    });
  };

  render() {
    return (
      <Form as="section" className="iws-tab-nav">
        <Form
          as="div"
          className="tabs d-flex align-items-start justify-content-start flex-wrap"
        >
          {this.state.navItems.map((item, index) => (
            <Form
              as="div"
              role="button"
              className={`py-1 my-1 mx-3  tab ${
                index === this.state.selected ? "tab-active" : ""
              }`}
              key={"tab-" + index}
              onClick={(event) => this._setContent(event, item.component)}
            >
              {this.icon(item?.icon)} {item.title}
            </Form>
          ))}
        </Form>
        <Form
          as="div"
          className="tab-content m-4"
          id={"container-" + this.state.container}
        >
          {this.state.content}
        </Form>
      </Form>
    );
  }
}
